/* unplugin-vue-components disabled */import { render } from "./ClassAddStudentDialog.vue?vue&type=template&id=0bafa4e1&scoped=true"
import script from "./ClassAddStudentDialog.vue?vue&type=script&lang=js"
export * from "./ClassAddStudentDialog.vue?vue&type=script&lang=js"

import "./ClassAddStudentDialog.vue?vue&type=style&index=0&id=0bafa4e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bafa4e1"]])

export default __exports__